import { StoryblokImage } from './storyblok-common.models';

export enum PAGE_TYPES {
  categories = 'categories',
  'landing-pages' = 'landing-pages',
}

export interface SelectionInfo {
  selectedSlug: string;
  pageType?: PAGE_TYPES;
}

export interface CategoryCard {
  image: StoryblokImage;
  title: string;
  categoySelectionLink: SelectionInfo;
}
